import React from "react";
import { ServiceCard } from "components";
import { SERVICES_DATA } from "data";

const ServicesSection = () => {
  return (
    <div className="w-full py-28 px-4 bg-white" id="services">
      <h1 className="text-center text-4xl font-semibold mb-20">Our Services</h1>
      <div className="max-w-[1240px] mx-auto grid md:grid-cols-3 gap-8">
        {SERVICES_DATA.map((service) => (
          <ServiceCard
            key={service.id}
            customCss={service.customCSS}
            title={service.title}
            description={service.description}
          />
        ))}
      </div>
    </div>
  );
};

export default ServicesSection;
